import { themeAssetUrl } from './themeAssets';

export function loadSwiper() {
  const isSwiperLibLoaded = typeof Swiper === 'function';
  if (isSwiperLibLoaded) {
    return $.when();
  }

  return $.cachedScript(themeAssetUrl('js', 'swiper.js'));
}
